import { render, staticRenderFns } from "./PartidaequipamientoFormHeader.vue?vue&type=template&id=6b0a11b8"
import script from "./PartidaequipamientoFormHeader.vue?vue&type=script&lang=js"
export * from "./PartidaequipamientoFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports